import { PaymentCancellationDrawer } from "../../../components/PaymentCancellationDrawer";
import type { PaymentCancellationResult } from "../../../components/PaymentCancellationDrawer";
import type { PaymentRow } from "./personDetailTypes";

type PersonPaymentCancellationDrawerProps = {
  canWriteFinance: boolean;
  open: boolean;
  payments: PaymentRow[] | null;
  personId: string;
  onClose: () => void;
  onSuccess: (result: PaymentCancellationResult) => void;
};

export function PersonPaymentCancellationDrawer({
  canWriteFinance,
  open,
  payments,
  personId,
  onClose,
  onSuccess
}: PersonPaymentCancellationDrawerProps) {
  if (!canWriteFinance || !open) return null;

  return (
    <PaymentCancellationDrawer
      open
      payments={(payments ?? []).map((p) => ({
        id: p.id,
        voidableRemaining:
          p.voidableRemaining != null ? Number(p.voidableRemaining) : Number(p.amount || 0),
        originalAmount: Number(p.amount || 0),
        paidDate: p.paidDate ?? null,
        method: p.method ?? null,
        reference: p.reference ?? null
      }))}
      onClose={onClose}
      onSuccess={onSuccess}
      personId={personId}
    />
  );
}
